export default "/images/vendor/flag-icon-css/flags/1x1/si.svg?4b2b84595a3a317f733a5bf1d140b423";